export default "__VITE_ASSET__DeXd9Gnb__"